import * as React from "react";
import { CountdownTimer as CountdownTimer$1 } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
const CmsCountdownTimer = ({ component, page }) => {
  const { document: documentRef } = component.getParameters();
  if (!documentRef) {
    return null;
  }
  const documentGetContent = documentRef && page.getContent(documentRef);
  const document = documentGetContent && documentGetContent.getData();
  if (!document || !document.countdown) {
    return null;
  }
  const {
    countdown: { endDate, countdownText, showCountdown, url, layout }
  } = document;
  return /* @__PURE__ */ React.createElement(
    CountdownTimer$1,
    {
      endDate,
      countdownText,
      showCountdown,
      url,
      layout
    }
  );
};
const CountdownTimer = compose(
  withHidableContent,
  withBreakpointVisibility,
  withBloomreachData,
  withEditableContent
)(CmsCountdownTimer);
export {
  CmsCountdownTimer,
  CountdownTimer as default
};
//# sourceMappingURL=CountdownTimer.js.map
